let language = {
   CARD_SELECTION_MODE: "Card Selection Mode:",
   RANDOMIZED_MODEL: "Randomized",
   FIXED_SET_MODEL: "Fixed Set",
}

export { language }